import React from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
import  '../../custom.css';
import SubFormRows from './SubFormRows';
import { getUserInfo } from '../../../../Utils/UserFunctions';

const SubFormBody = (props)=>{
    const {subformIndex,sectionSubformData,pageType,modType,isWrite,section,reminderDisplayText,shouldRenderButton} = props;
    //REMOVE SUBFORM HANDLER
    let sectionData = section.data;
    const userInfo = getUserInfo();
    if (userInfo?.data?.role_name === 'Community Partners') {
      sectionData = section.data.filter(
        (item) => item.api_custom_field_name !== "cf_quoted_cost"
      );
    }
    const colCount = sectionData.filter((item) => {
        return isSet(item.access_mode, 'EDITABLE') !== 'HIDDEN';
      }).length;
      
    return(
        <tbody> 
            {sectionSubformData.subform_rows.map((rowData,rowIndex)=>{
                
                        return(
                                <SubFormRows 
                                    key={rowIndex}
                                    rowIndex={rowIndex}
                                    sectionData={sectionData}
                                    rowData={rowData}
                                    modType={modType}
                                    isWrite={isWrite}
                                    updateSubformRow={props.updateSubformRow}
                                    saveAndUpdateSubform={props.saveAndUpdateSubform}
                                    sectionSubformData={sectionSubformData}
                                    pageType={pageType}
                                    reminderDisplayText={reminderDisplayText}
                                    section={section}
                                    removeSubformDataHandler={props.removeSubformDataHandler}
                                    onChangeInputAction={props.onChangeInputAction}
                                    subformIndex={subformIndex}
                                    shouldRenderButton={shouldRenderButton}
                                    />
                            )
            })}
            {isSet(sectionSubformData.subform_rows,[]).length===0 &&
            <tr>
                <td colspan={colCount} className='text-center'>No Record exists</td>
            </tr>}
        </tbody>
    )
}

export default SubFormBody;